import React from "react";
import { Button as ChakraButton } from "@chakra-ui/react";

const Button = function Button({ children, ...rest }) {
  return <ChakraButton {...rest}>{children}</ChakraButton>;
};

export default Button;
